import { render, staticRenderFns } from "./SpaceSwitch.vue?vue&type=template&id=82e06858&scoped=true&"
import script from "./SpaceSwitch.vue?vue&type=script&lang=js&"
export * from "./SpaceSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e06858",
  null
  
)

export default component.exports